import request from "@/axios/index";
// 获取语言类型
export function getLanguageTpye(params) {
  return request({
    url: "/i18n/lang_code",
    method: "get",
    params
  });
}
// 获取语言设置数据
export function getLanguageList(params) {
    return request({
      url: "/i18n",
      method: "get",
      params
    });
  }
// 保存语言设置
export function setLanguageList(params,data) {
    return request({
      url: "/i18n",
      method: "post",
      data,
      params
    });
  }
